import {RefObject, useEffect} from "react";

interface IProps {
    dataLength: number;
    stickyElementRef: RefObject<HTMLDivElement | null>;
    tableRowsRef: RefObject<HTMLDivElement | null>;
    shrinkWidthToData?: boolean;
}

export const useStickyHeaderMaxWidth = (props: IProps) => {
    const {dataLength, stickyElementRef, tableRowsRef, shrinkWidthToData} = props;
    useEffect(() => {
        if (!shrinkWidthToData) return;

        const tableRowsContainer = tableRowsRef.current;
        const stickyHeader = stickyElementRef.current;

        if (!tableRowsContainer || !stickyHeader) return;

        const updateMaxWidth = () => {
            const marginLeft = parseFloat(window.getComputedStyle(tableRowsContainer).marginLeft) || 0;
            stickyHeader.style.maxWidth = marginLeft + tableRowsContainer.offsetWidth + "px";
        };

        const observer = new ResizeObserver(updateMaxWidth);
        observer.observe(tableRowsContainer);
        updateMaxWidth();

        return () => observer.disconnect();
    }, [shrinkWidthToData, dataLength]);
};
import {RefObject, useEffect} from "react";

interface IProps {
    dataLength: number;
    stickyElementRef: RefObject<HTMLDivElement | null>;
    tableRowsRef: RefObject<HTMLDivElement | null>;
    shrinkWidthToData?: boolean;
}

export const useStickyHeaderMaxWidth = (props: IProps) => {
    const {dataLength, stickyElementRef, tableRowsRef, shrinkWidthToData} = props;
    useEffect(() => {
        if (!shrinkWidthToData) return;

        const tableRowsContainer = tableRowsRef.current;
        const stickyHeader = stickyElementRef.current;

        if (!tableRowsContainer || !stickyHeader) return;

        const updateMaxWidth = () => {
            const marginLeft = parseFloat(window.getComputedStyle(tableRowsContainer).marginLeft) || 0;
            stickyHeader.style.maxWidth = marginLeft + tableRowsContainer.offsetWidth + "px";
        };

        const observer = new ResizeObserver(updateMaxWidth);
        observer.observe(tableRowsContainer);
        updateMaxWidth();

        return () => observer.disconnect();
    }, [shrinkWidthToData, dataLength]);
};
